import React from 'react';
import { CheckCircle2 } from "lucide-react";
import { useAuth } from '../../contexts/AuthContext';

const HeroSection: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="relative bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32 min-h-[560px]">

          <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28 text-center">
            <div className="sm:text-center lg:text-left">

              {/* Updated Headline */}
              <h1 className="text-5xl tracking-tight font-extrabold text-gray-900 sm:text-6xl md:text-7xl">
                <span className="block">Broker–Carrier Relationships</span>
                <span className="block text-blue-600">Made Simple</span>
              </h1>

              {/* Updated Supporting Text */}
              <p className="mt-4 text-xl text-gray-600 sm:max-w-xl sm:mx-auto lg:mx-0">
                One registration. Multiple partners. Zero compliance headaches.
              </p>

              <p className="mt-3 text-base text-gray-500 sm:max-w-xl sm:mx-auto lg:mx-0">
                Join brokers who streamline carrier onboarding and compliance with ease.
              </p>

              {/* CTA Buttons */}
              <div className="mt-6 sm:mt-8 sm:flex sm:justify-center lg:justify-start gap-3">
                {isAuthenticated ? (
                  <div className="rounded-md shadow">
                    <a
                      href="/dashboard"
                      className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg md:px-10"
                    >
                      Go to Dashboard
                    </a>
                  </div>
                ) : (
                  <>
                    <div className="rounded-md shadow">
                      <a
                        href="/register/broker?trial=true"
                        className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg md:px-10"
                      >
                        Start 7-Day Free Trial
                      </a>
                    </div>
                    
                    <div className="mt-3 sm:mt-0">
                      <a
                        href="/pricing"
                        className="w-full flex items-center justify-center px-8 py-3 border-2 border-blue-600 text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50 md:py-4 md:text-lg md:px-10"
                      >
                        Buy Now
                      </a>
                    </div>
                  </>
                )}
              </div>

              <div className="mt-6 sm:mt-8 text-sm text-gray-400">
                <p>✓ No credit card required for trial</p>
                <p>✓ 7-day free trial</p>
                <p>✓ Cancel anytime</p>
              </div>

            </div>
          </main>
        </div>
      </div>

      <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
        <div className="relative h-[360px] sm:h-[440px] md:h-[520px] lg:h-full flex items-center">
          <div aria-hidden className="absolute inset-0 -z-10 bg-gradient-to-br from-indigo-50 via-white to-purple-50" />
<div className="w-full max-w-md lg:max-w-lg mx-auto rounded-xl border border-gray-200 bg-white/90 backdrop-blur shadow-lg overflow-hidden">
              <div>
                <video
                  width="100%"
                  controls
                  poster="/images/loaddrive-cover.png"
                  className="rounded-t-xl w-full"
                  style={{ objectFit: 'contain' }}
                >
                  <source src="/videos/loadDrive.mp4" type="video/mp4" />
                </video>
              </div>
              <div className="p-4">
                <p className="text-sm text-gray-600 text-center">See how LoadDrive streamlines carrier onboarding</p>
              </div>
            </div>
        </div>
      </div>

    </div>
  );
};

export default HeroSection;
